import { useUserIdentityState } from '@provider/user-identity';
import { ShareWithUserIcon } from '@ui/kit/icons';
import { UniversalContextMenuButton } from '../molecule.contextmenu.js';
import { useFinishComponentInteraction } from './interaction.finish.js';
import { jsx } from 'react/jsx-runtime';
import { useEntriesForComponent } from '../../../api.component-entry/query.get-all.js';
import { useComponentEntry } from '../../../api.component-entry/query.get.js';

function ShareButton(props) {
  const user = useUserIdentityState(state => state.user);
  const {
    data: hasShared
  } = useComponentEntry(props.entryKey, {
    select: entry => !!entry?.envelope.shared
  });
  const {
    data: canShare
  } = useComponentEntry(props.entryKey, {
    select: entry => !!entry?.envelope.objectID
  });
  const {
    data: currentEntryId
  } = useComponentEntry(props.entryKey, {
    select: entry => entry?.envelope.objectID
  });
  const finishInteraction = useFinishComponentInteraction({
    entryKey: props.entryKey,
    onShareWithTeacher: props.onShareWithTeacher
  });
  const {
    data: hasSharedPreviously
  } = useEntriesForComponent(props.componentId, {
    select: entries => entries.some(entry => entry.envelope.objectID !== currentEntryId && entry.envelope.shared)
  });
  const tooltip = (() => {
    if (!user) {
      return {
        body: "Du er ikke logget ind. Kun indloggede elever kan dele med lærer.",
        ariaType: "description"
      };
    }
    if (user.role === "teacher") {
      return {
        body: "Du er logget ind som lærer. Kun elever kan dele med lærer.",
        ariaType: "description"
      };
    }
    if (hasShared) {
      return {
        body: "Besvarelsen er delt med din lærer",
        ariaType: "description"
      };
    }
    if (!canShare) {
      return {
        body: "Du skal besvare opgaven, før du kan dele den med din lærer",
        ariaType: "description"
      };
    }
    if (hasSharedPreviously) {
      return {
        body: "Del det nyeste svar med din lærer. (Du har delt et tidligere svar.)",
        ariaType: "description"
      };
    }
  })();
  return /*#__PURE__*/jsx(UniversalContextMenuButton, {
    className: props.className,
    disabled: props.disabled || hasShared || !canShare || user?.role !== "student",
    layout: props.layout,
    state: hasShared ? "success" : hasSharedPreviously ? "partial-success" : undefined,
    as: "button",
    label: "Del med l\xE6rer",
    tooltip: tooltip,
    onClick: () => {
      finishInteraction();
      props.onClick?.();
    },
    icon: /*#__PURE__*/jsx(ShareWithUserIcon, {
      height: 20
    })
  });
}

export { ShareButton };
//# sourceMappingURL=button.js.map
